import { Carousel } from '../../views/ts/components/Carousel';
import { LazyLoader } from '../../views/ts/components/LazyLoader';
import { Menu } from '../twig/components/Menu';
import { PrevNextCursor } from '../twig/components/PrevNextCursor';
import { FrontPage } from '../twig/pages/front-page';
/*
(new Collapse()).init();
(new Demo()).init();
(new Dropdown()).init();*/
(new Carousel()).init();
(new LazyLoader()).init();
(new PrevNextCursor()).init();
(new Menu()).init();
(new FrontPage()).init();
/*(new Menu()).init();*/
